module.exports = __webpack_public_path__ + "img/7.ffeff45b.png";